
<div class="outer">
    <!-- <span class="error-code">You are Successfully Logged out</span> -->
    <span class="material-icons error-code">lock</span>
    <h1 class="error-msg">Please logout from the Cummins Azure SSO and close 
        the window to completely logout from this application</h1>
    <a href="{{url}}" class="error-link">GO TO LOGIN PAGE</a>
    <!-- <a  routerLink="{{url}}" class="error-link">GO TO LOGIN PAGE</a> -->
</div>

